// @ts-nocheck
/* eslint-disable */
/* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */
import { ReactComponent as LogoCloudComposer } from '../../../assets/images/Logos/logo-cloud-composer.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoCloudComposerIcon = /* @__PURE__ */ withLogoClass(LogoCloudComposer);
